import { render, staticRenderFns } from "./ModelingProcess.vue?vue&type=template&id=36518d3f&scoped=true&"
import script from "./ModelingProcess.vue?vue&type=script&lang=js&"
export * from "./ModelingProcess.vue?vue&type=script&lang=js&"
import style0 from "./ModelingProcess.vue?vue&type=style&index=0&id=36518d3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36518d3f",
  null
  
)

export default component.exports